import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, toObservable } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { esFolio } from "app/logic/guias";
import * as globals from "app/resources/globals";
import { MultiselectorGuiaList } from "./components/list";
import { SeleccionGuiasRX } from "./selector";
import { ResumenGuiaAFacturar } from "./resumen";
import { FacturaGuia } from "./factura";

const resource = resources.FacturacionOnline;

type Entity = models.FacturacionOnlineParametros;
export interface Props {
    value: Entity;
    onChange: (x: Entity) => void;
}

export interface State {
    facturacionOnline?: models.FacturacionOnline;
}

class FacturacionOnlineFormNoRx extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    value = (x: Props, state: State) => x.value;
    FolioGuia = (x: Props) => x.value.FolioGuia;
    ClaveCliente = (x: Props) => x.value.ClaveCliente;
    valueValido = createSelectorRx(this.FolioGuia, this.ClaveCliente, (FolioGuia, ClaveCliente) => FolioGuia != "" && FolioGuia != null && ClaveCliente != 0);

    guias = createSelectorRx(this.value, value => observeResource(resource.ObtenerGuiasAFacturarOnline, value.FolioGuia, value.ClaveCliente));
    factura = createSelectorRx(this.value, value => observeResource(resource.ObtenerFacturaGuia, value.FolioGuia, value.ClaveCliente));
    esFacturado = createSelectorRx(this.factura, factura => factura != null);
    guiaAFacturar = createSelectorRx(this.value, (value) => observeResource(resource.ObtenerInformacionGuiaFacturacionOnline, value.FolioGuia, value.ClaveCliente));
    tieneValorGuia = createSelectorRx(this.guiaAFacturar, guiaAFacturar => guiaAFacturar != null);

    nuevaFacturacion = (x: Props, state: State) => (
        {
            Receptor: {
                Nombre: "",
                Rfc: "",
                TipoPersona: models.TipoPersona.Fisica,
                NumeroRegistroIdentidadFiscal: "",
                ResidenciaFiscal: ""
            },
            CorreoFacturacion: "",
            IdColoniaFacturacionOnline: null,
            DireccionFacturacionOnline: {
                Calle: "",
                NoExterior: "",
                NoInterior: ""
            },
            Folios: []
        } as models.FacturacionOnline
    )

    facturacionFromResource = createSelectorRx(this.guiaAFacturar, this.tieneValorGuia, (guiaAFacturar, tieneValor) => {
        return tieneValor ?
            {
                Receptor: guiaAFacturar.Receptor,
                CorreoFacturacion: guiaAFacturar.CorreoFacturacion,
                DireccionFacturacionOnline: guiaAFacturar.DireccionFacturacionOnline,
                IdColoniaFacturacionOnline: guiaAFacturar.IdColoniaFacturacionOnline,
                Folios: []
            } as models.FacturacionOnline
            : undefined
    });

    facturacionOnlineFromState = (x: Props, state: State) => state.facturacionOnline;

    facturacion = createSelectorRx(this.facturacionFromResource, this.nuevaFacturacion, this.facturacionOnlineFromState, (fromResource, nuevaFacturacion, fromState) => fromState || fromResource || nuevaFacturacion);
    onChange = (value: models.FacturacionOnline) => new Promise<void>(resolve => this.setState({ facturacionOnline: value }, resolve));

    onFacturar = async () => {
        const { FolioGuia, ClaveCliente } = this.props.value;
        await this.props.onChange({ ClaveCliente: ClaveCliente, FolioGuia: FolioGuia });
    }

    handleOnLimpiar = async () => {
        await this.props.onChange({ ClaveCliente: undefined, FolioGuia: "" });
        history.go("../");
    }

    render() {
        const value = this.value(this.props, this.state);
        const facturacion = this.facturacion(this.props, this.state);
        const valueValido = this.valueValido(this.props);
        const guias = this.guias(this.props, this.state);
        const factura = this.factura(this.props, this.state);
        const esFacturado = this.esFacturado(this.props, this.state);
        const tieneValorGuia = this.tieneValorGuia(this.props, this.state);
        const guiaAFacturar = this.guiaAFacturar(this.props, this.state);

        return (
            <div>
                <kea.Title titulo={"Facturar Guías"} onLimpiar={this.handleOnLimpiar}>
                </kea.Title>
                {
                    valueValido ?
                        <kea.Tab items={[
                            {
                                title: "" + value.FolioGuia,
                                body: <ResumenGuiaAFacturar value={guiaAFacturar} onFacturar={this.onFacturar} factura={factura} existeGuia={tieneValorGuia} facturaOnline={facturacion} onChange={this.onChange} />
                            },

                            {
                                title: "Seleccionar guias a facturar",
                                body: <SeleccionGuiasRX items={guias} FolioGuia={value.FolioGuia} esFacturada={esFacturado} onFacturar={this.onFacturar} facturaOnline={facturacion} onChange={this.onChange} />
                            }
                        ]} />
                        : <div className="alert alert-info">
                            <label>No hay datos agregados para facturación online</label>
                            <br />
                            Verifiqué los datos de busqueda de <b>facturación</b>
                        </div>
                }
            </div>
        );
    }
}

const FacturacionOnlineFormRx = componentToRx(FacturacionOnlineFormNoRx);
export const FacturacionOnlineForm = kea.defaultProps(FacturacionOnlineFormRx, {
    value: globals.state.map(x => x.facturacionOnline || { FolioGuia: "", ClaveCliente: undefined }),
    onChange: (x: Entity) => globals.setState(prev => ({ ...prev, facturacionOnline: x }))
});



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/facturaciononline/edit/facturacion.tsx